type Ownership = {createdBy?: string | null; addedBy?: string | null};
type PrivacyTask = Ownership & {private?: boolean | null; assignedTo?: string | null; assignedToType?: string | null;
    billable?: boolean | null; entityId?:string|null; entityType?: string; relatedTo?: string[] | null; invoiceId?: string | null;
    flatFeeBucket?: string | null; flatFeeMilestoneBucket?: string | null; docketId?:string|null; waitingOn?: unknown[]|null; tieIns?: unknown[] | null};

export const PRIVATE_TASK_LINK_REASON = 'Make this task public before linking it.';
export const canLinkTaskToFirmEntity = (task: PrivacyTask): boolean => !task.private;

export function isPersonalTask(task: PrivacyTask): boolean {
    return (!task.entityId || task.entityId === '00000000-0000-0000-0000-000000000000') && (!task.entityType || task.entityType === 'task')
        && !task.relatedTo?.length && !task.invoiceId && !task.flatFeeBucket && !task.flatFeeMilestoneBucket
        && !task.docketId && !task.waitingOn?.length && !task.tieIns?.length;
}

export function canMarkTaskPrivate(task: PrivacyTask, currentUserId?: string | null): boolean {
    const creator = task.createdBy || task.addedBy;
    return !!currentUserId && creator === currentUserId && isPersonalTask(task)
        && (task.assignedToType == null || task.assignedToType === 'U')
        && (!task.assignedTo || task.assignedTo === creator);
}

export function isPrivateTaskVisible(task: PrivacyTask, currentUserId?: string | null): boolean {
    return !task.private || !!currentUserId && (task.createdBy || task.addedBy) === currentUserId;
}

export function isPrivateTemplateVisible(template: Ownership & {global?: boolean | null}, currentUserId?: string | null): boolean {
    return template.global !== false || !!currentUserId && (template.createdBy || template.addedBy) === currentUserId;
}

export function hasNoExistingCategory(template: {categories?: string[]}, categories: {get(id: string): unknown}): boolean {
    return (template.categories ?? []).every(id => !categories.get(id));
}
